(function(SK){
// ---------- Astronomy engine ----------
var D2R = Math.PI / 180, R2D = 180 / Math.PI;
function norm360(x) { var r = x % 360; return r < 0 ? r + 360 : r; }
function julianDay(y, m, d, h, mi, s) {
s = s || 0;
if (m <= 2) { y -= 1; m += 12; }
var a = Math.floor(y / 100), b = 2 - a + Math.floor(a / 4);
var frac = d + (h + mi / 60 + s / 3600) / 24;
return Math.floor(365.25 * (y + 4716)) + Math.floor(30.6001 * (m + 1)) + frac + b - 1524.5;
}
function eccAnomaly(M, e) {
var Mr = norm360(M) * D2R, E = M + (e * R2D) * Math.sin(Mr) * (1 + e * Math.cos(Mr));
for (var i = 0; i < 8; i++) {
var Er = E * D2R;
var dE = (E - (e * R2D) * Math.sin(Er) - M) / (1 - e * Math.cos(Er));
E -= dE;
if (Math.abs(dE) < 1e-6) break;
}
return E;
}
var EL = {
sun:     { N:[0,0],           i:[0,0],        w:[282.9404,4.70935e-5], a:[1.0,0],     e:[0.016709,-1.151e-9], M:[356.047,0.9856002585] },
moon:    { N:[125.1228,-0.0529538083], i:[5.1454,0], w:[318.0634,0.1643573223], a:[60.2666,0], e:[0.0549,0], M:[115.3654,13.0649929509] },
mercury: { N:[48.3313,3.24587e-5], i:[7.0047,5.0e-8], w:[29.1241,1.01444e-5], a:[0.387098,0], e:[0.205635,5.59e-10], M:[168.6562,4.0923344368] },
venus:   { N:[76.6799,2.4659e-5],  i:[3.3946,2.75e-8], w:[54.891,1.38374e-5], a:[0.72333,0],  e:[0.006773,-1.302e-9], M:[48.0052,1.6021302244] },
mars:    { N:[49.5574,2.11081e-5], i:[1.8497,-1.78e-8], w:[286.5016,2.92961e-5], a:[1.523688,0], e:[0.093405,2.516e-9], M:[18.6021,0.5240207766] },
jupiter: { N:[100.4542,2.76854e-5], i:[1.303,-1.557e-7], w:[273.8777,1.64505e-5], a:[5.20256,0], e:[0.048498,4.469e-9], M:[19.895,0.0830853001] },
saturn:  { N:[113.6634,2.3898e-5], i:[2.4886,-1.081e-7], w:[339.3939,2.97661e-5], a:[9.55475,0], e:[0.055546,-9.499e-9], M:[316.967,0.0334442282] }
};
function el(e, d, k) { return e[k][0] + e[k][1] * d; }
function helio(name, d) {
var e = EL[name];
var N = norm360(el(e,d,"N")), i = el(e,d,"i"), w = norm360(el(e,d,"w"));
var a = el(e,d,"a"), ecc = el(e,d,"e"), M = norm360(el(e,d,"M"));
var E = eccAnomaly(M, ecc);
var xv = a * (Math.cos(E*D2R) - ecc), yv = a * Math.sqrt(1-ecc*ecc) * Math.sin(E*D2R);
var v = Math.atan2(yv, xv) * R2D, r = Math.sqrt(xv*xv + yv*yv);
var vw = (v+w) * D2R, Nr = N*D2R, ir = i*D2R;
return {
x: r * (Math.cos(Nr)*Math.cos(vw) - Math.sin(Nr)*Math.sin(vw)*Math.cos(ir)),
y: r * (Math.sin(Nr)*Math.cos(vw) + Math.cos(Nr)*Math.sin(vw)*Math.cos(ir)),
z: r * Math.sin(vw) * Math.sin(ir)
};
}
function geoLon(name, d) {
if (name === "sun") {
var e = EL.sun, M = norm360(el(e,d,"M")), w = norm360(el(e,d,"w")), ecc = el(e,d,"e");
var E = eccAnomaly(M, ecc);
var xv = Math.cos(E*D2R) - ecc, yv = Math.sqrt(1-ecc*ecc) * Math.sin(E*D2R);
return norm360(Math.atan2(yv, xv) * R2D + w);
}
if (name === "moon") {
var em = EL.moon, N = norm360(el(em,d,"N")), i = el(em,d,"i"), w = norm360(el(em,d,"w"));
var a = el(em,d,"a"), ecc = el(em,d,"e"), M = norm360(el(em,d,"M"));
var E = eccAnomaly(M, ecc);
var xv = a * (Math.cos(E*D2R) - ecc), yv = a * Math.sqrt(1-ecc*ecc) * Math.sin(E*D2R);
var v = Math.atan2(yv, xv) * R2D, r = Math.sqrt(xv*xv + yv*yv);
var vw = (v+w)*D2R, Nr = N*D2R, ir = i*D2R;
var xh = r*(Math.cos(Nr)*Math.cos(vw) - Math.sin(Nr)*Math.sin(vw)*Math.cos(ir));
var yh = r*(Math.sin(Nr)*Math.cos(vw) + Math.cos(Nr)*Math.sin(vw)*Math.cos(ir));
var lon = Math.atan2(yh, xh) * R2D;
var Ls = norm360(el(EL.sun,d,"M") + el(EL.sun,d,"w"));
var Lm = norm360(N + w + M);
var Ms = norm360(el(EL.sun,d,"M"));
var Mm = norm360(M);
var D_ = norm360(Lm - Ls);
lon += -1.274 * Math.sin((Mm - 2*D_)*D2R)
+ 0.658 * Math.sin(2*D_*D2R)
+ -0.186 * Math.sin(Ms*D2R)
+ -0.059 * Math.sin((2*Mm - 2*D_)*D2R)
+ -0.057 * Math.sin((Mm - 2*D_ + Ms)*D2R)
+ 0.053 * Math.sin((Mm + 2*D_)*D2R)
+ 0.046 * Math.sin((2*D_ - Ms)*D2R)
+ 0.041 * Math.sin((Mm - Ms)*D2R)
+ -0.035 * Math.sin(D_*D2R)
+ -0.031 * Math.sin((Mm + Ms)*D2R);
return norm360(lon);
}
var p = helio(name, d);
var es = EL.sun, Me = norm360(el(es,d,"M")), we = norm360(el(es,d,"w")), ecce = el(es,d,"e");
var Ee = eccAnomaly(Me, ecce);
var xe = Math.cos(Ee*D2R) - ecce, ye = Math.sqrt(1-ecce*ecce) * Math.sin(Ee*D2R);
var ve = Math.atan2(ye, xe) * R2D, re = Math.sqrt(xe*xe + ye*ye);
var vwe = (ve+we)*D2R;
// (xE, yE) is Sun's geocentric position. Planet geocentric = planet helio + Sun geo.
var xE = re*Math.cos(vwe), yE = re*Math.sin(vwe);
return norm360(Math.atan2(p.y + yE, p.x + xE) * R2D);
}
function rahuLon(d) { return norm360(el(EL.moon, d, "N")); }
function lahiri(jd) {
var T = (jd - 2451545.0) / 36525;
return 23.85333 + 1.396 * T - 0.000031 * T * T;
}
function sidereal(trop, ay) { return norm360(trop - ay); }
function ascendantTrop(jd, lat, lon) {
var T = (jd - 2451545.0) / 36525;
var gmst = 280.46061837 + 360.98564736629 * (jd - 2451545.0) + 0.000387933*T*T - T*T*T/38710000;
var LST = norm360(gmst + lon);
var eps = 23.4392911 * D2R, lst = LST * D2R, la = lat * D2R;
// Ascendant = ecliptic point on the eastern horizon.
var y = Math.cos(lst);
var x = -(Math.sin(lst) * Math.cos(eps) + Math.tan(la) * Math.sin(eps));
return norm360(Math.atan2(y, x) * R2D);
}
function isRetrograde(name, d) {
if (name === "sun" || name === "moon") return false;
var b = geoLon(name, d - 0.5), a = geoLon(name, d + 0.5);
var delta = norm360(a - b + 180) - 180;
return delta < 0;
}
SK.astro = { D2R:D2R, R2D:R2D, norm360:norm360, julianDay:julianDay, eccAnomaly:eccAnomaly, EL:EL, el:el, helio:helio, geoLon:geoLon, rahuLon:rahuLon, lahiri:lahiri, sidereal:sidereal, ascendantTrop:ascendantTrop, isRetrograde:isRetrograde };
// ---------- Vedic data ----------
var RASHIS = [
{en:"Aries",sa:"मेष",key:"mesha",lord:"Mars",el:"Fire"},
{en:"Taurus",sa:"वृषभ",key:"vrishabha",lord:"Venus",el:"Earth"},
{en:"Gemini",sa:"मिथुन",key:"mithuna",lord:"Mercury",el:"Air"},
{en:"Cancer",sa:"कर्क",key:"karka",lord:"Moon",el:"Water"},
{en:"Leo",sa:"सिंह",key:"simha",lord:"Sun",el:"Fire"},
{en:"Virgo",sa:"कन्या",key:"kanya",lord:"Mercury",el:"Earth"},
{en:"Libra",sa:"तुला",key:"tula",lord:"Venus",el:"Air"},
{en:"Scorpio",sa:"वृश्चिक",key:"vrishchika",lord:"Mars",el:"Water"},
{en:"Sagittarius",sa:"धनु",key:"dhanu",lord:"Jupiter",el:"Fire"},
{en:"Capricorn",sa:"मकर",key:"makara",lord:"Saturn",el:"Earth"},
{en:"Aquarius",sa:"कुम्भ",key:"kumbha",lord:"Saturn",el:"Air"},
{en:"Pisces",sa:"मीन",key:"meena",lord:"Jupiter",el:"Water"}
];
var NAKSHATRAS = [
{en:"Ashwini",sa:"अश्विनी",lord:"Ketu"},{en:"Bharani",sa:"भरणी",lord:"Venus"},
{en:"Krittika",sa:"कृत्तिका",lord:"Sun"},{en:"Rohini",sa:"रोहिणी",lord:"Moon"},
{en:"Mrigashira",sa:"मृगशिरा",lord:"Mars"},{en:"Ardra",sa:"आर्द्रा",lord:"Rahu"},
{en:"Punarvasu",sa:"पुनर्वसु",lord:"Jupiter"},{en:"Pushya",sa:"पुष्य",lord:"Saturn"},
{en:"Ashlesha",sa:"आश्लेषा",lord:"Mercury"},{en:"Magha",sa:"मघा",lord:"Ketu"},
{en:"Purva Phalguni",sa:"पूर्व फाल्गुनी",lord:"Venus"},{en:"Uttara Phalguni",sa:"उत्तर फाल्गुनी",lord:"Sun"},
{en:"Hasta",sa:"हस्त",lord:"Moon"},{en:"Chitra",sa:"चित्रा",lord:"Mars"},
{en:"Swati",sa:"स्वाति",lord:"Rahu"},{en:"Vishakha",sa:"विशाखा",lord:"Jupiter"},
{en:"Anuradha",sa:"अनुराधा",lord:"Saturn"},{en:"Jyeshtha",sa:"ज्येष्ठा",lord:"Mercury"},
{en:"Mula",sa:"मूल",lord:"Ketu"},{en:"Purva Ashadha",sa:"पूर्व आषाढा",lord:"Venus"},
{en:"Uttara Ashadha",sa:"उत्तर आषाढा",lord:"Sun"},{en:"Shravana",sa:"श्रवण",lord:"Moon"},
{en:"Dhanishta",sa:"धनिष्ठा",lord:"Mars"},{en:"Shatabhisha",sa:"शतभिषा",lord:"Rahu"},
{en:"Purva Bhadrapada",sa:"पूर्व भाद्रपद",lord:"Jupiter"},{en:"Uttara Bhadrapada",sa:"उत्तर भाद्रपद",lord:"Saturn"},
{en:"Revati",sa:"रेवती",lord:"Mercury"}
];
var PLANETS = [
{k:"sun",en:"Sun",sa:"सूर्य",s:"Su",c:"#e5793b"},
{k:"moon",en:"Moon",sa:"चन्द्र",s:"Mo",c:"#e7dcc1"},
{k:"mars",en:"Mars",sa:"मंगल",s:"Ma",c:"#c94833"},
{k:"mercury",en:"Mercury",sa:"बुध",s:"Me",c:"#7bbf67"},
{k:"jupiter",en:"Jupiter",sa:"गुरु",s:"Ju",c:"#d8b34d"},
{k:"venus",en:"Venus",sa:"शुक्र",s:"Ve",c:"#e0b0d6"},
{k:"saturn",en:"Saturn",sa:"शनि",s:"Sa",c:"#5f7db1"},
{k:"rahu",en:"Rahu",sa:"राहु",s:"Ra",c:"#7a5aa8"},
{k:"ketu",en:"Ketu",sa:"केतु",s:"Ke",c:"#a0724a"}
];
var DASHA_YEARS = {Ketu:7,Venus:20,Sun:6,Moon:10,Mars:7,Rahu:18,Jupiter:16,Saturn:19,Mercury:17};
var DASHA_ORDER = ["Ketu","Venus","Sun","Moon","Mars","Rahu","Jupiter","Saturn","Mercury"];
var TRAITS = {
mesha:{s:"Pioneering courage, quick decisions, unshakable will.",c:"Impatience, blunt speech, burning out.",l:"You are here to initiate. Movement is your medicine — but pause to aim before you leap."},
vrishabha:{s:"Loyalty, artistic taste, ability to build lasting wealth.",c:"Stubbornness, comfort-seeking that blocks growth.",l:"You cultivate slow beauty. Money, art and love ripen in your hands — trust their timing."},
mithuna:{s:"Curiosity, wit, ability to connect ideas and people.",c:"Restlessness, scattered focus.",l:"You are a messenger. Choose fewer conversations, but let each one carry weight."},
karka:{s:"Deep empathy, nurturing presence.",c:"Mood tides, taking on others' pain.",l:"You are the keeper of the hearth. Guard your home first — the world will follow."},
simha:{s:"Natural leadership, warmth, generosity.",c:"Pride, needing applause.",l:"You are meant to shine. Lead with humility — the crown weighs less that way."},
kanya:{s:"Precision, service, healing hands, refined intellect.",c:"Over-criticism, worry, perfectionism.",l:"You are here to refine. Small acts done well change more than grand gestures."},
tula:{s:"Diplomacy, aesthetic sense, sense of fairness.",c:"Indecision, avoiding hard truths.",l:"You are the harmoniser. Speak your truth — the balance you seek starts within."},
vrishchika:{s:"Deep insight, magnetic presence, transformative power.",c:"Jealousy, secretiveness.",l:"You are the alchemist. Every ending you meet is another rebirth waiting."},
dhanu:{s:"Wisdom, optimism, love of freedom and truth.",c:"Bluntness, restlessness with routine.",l:"You are the seeker. The road is your temple — walk it with dharma."},
makara:{s:"Discipline, patience, mastery of long-form ambition.",c:"Coldness, workaholism.",l:"You climb the mountain slowly. Rest on the way — the peak is not the point."},
kumbha:{s:"Vision, humanitarian heart, original thinking.",c:"Emotional distance, rebellion for its own sake.",l:"You are the revolutionary. Serve the many, but do not forget the one beside you."},
meena:{s:"Compassion, imagination, spiritual sensitivity.",c:"Escapism, boundary loss.",l:"You are the mystic. Anchor your dreams in daily practice — the ocean needs shores."}
};
var RECS = {
mesha:[{t:"3 Mukhi Rudraksha",r:"Balances Mars — courage without recklessness.",q:"3 mukhi rudraksha"},{t:"Red Coral Pendant",r:"Amplifies leadership and vitality.",q:"red coral"}],
vrishabha:[{t:"6 Mukhi Rudraksha",r:"Harmonises Venus — love, beauty and abundance.",q:"6 mukhi rudraksha"},{t:"Diamond Silver Ring",r:"Strengthens ruling planet Venus.",q:"diamond ring"}],
mithuna:[{t:"4 Mukhi Rudraksha",r:"Sharpens Mercury — clarity in thought and speech.",q:"4 mukhi rudraksha"},{t:"Emerald (Panna) Pendant",r:"Ruling stone of Mercury.",q:"emerald"}],
karka:[{t:"2 Mukhi Rudraksha",r:"Calms the Moon — emotional balance.",q:"2 mukhi rudraksha"},{t:"Pearl (Moti) Ring",r:"Ruling stone of the Moon.",q:"pearl"}],
simha:[{t:"1 Mukhi Rudraksha",r:"Direct grace of Shiva — royal Sun energy.",q:"1 mukhi rudraksha"},{t:"Ruby (Manik) Pendant",r:"Amplifies confidence and vitality of the Sun.",q:"ruby"}],
kanya:[{t:"4 Mukhi Rudraksha",r:"Mercury remedy — dispels overthinking.",q:"4 mukhi rudraksha"},{t:"Emerald Bracelet",r:"Enhances discernment and clarity.",q:"emerald"}],
tula:[{t:"6 Mukhi Rudraksha",r:"Restores Venus — balance in relationships.",q:"6 mukhi rudraksha"},{t:"Diamond Studs",r:"Strengthens Venus, the ruling planet of Libra.",q:"diamond"}],
vrishchika:[{t:"3 Mukhi Rudraksha",r:"Cools intense Mars fire — releases old karmas.",q:"3 mukhi rudraksha"},{t:"Red Coral Ring",r:"Directs Mars into focused ambition.",q:"red coral"}],
dhanu:[{t:"5 Mukhi Rudraksha",r:"Jupiter blessing — wisdom, dharma, expansion.",q:"5 mukhi rudraksha"},{t:"Yellow Sapphire (Pukhraj)",r:"Ruling stone of Jupiter.",q:"yellow sapphire"}],
makara:[{t:"7 Mukhi Rudraksha",r:"Softens Saturn — steady effort rewarded.",q:"7 mukhi rudraksha"},{t:"Blue Sapphire (Neelam)",r:"Ruling stone of Saturn — worn with care.",q:"blue sapphire"}],
kumbha:[{t:"8 Mukhi Rudraksha",r:"Ganesha grace — removes obstacles for Saturn natives.",q:"8 mukhi rudraksha"},{t:"Amethyst Pendant",r:"Elevates Saturn's spiritual dimension.",q:"amethyst"}],
meena:[{t:"5 Mukhi Rudraksha",r:"Jupiter blessing — deepens intuition and faith.",q:"5 mukhi rudraksha"},{t:"Yellow Sapphire Ring",r:"Strengthens Guru — the ruling planet of Pisces.",q:"yellow sapphire"}]
};
var HORO_THEMES = [
"A conversation you have been avoiding will bring relief once begun.",
"Money moves quietly today — check what is already on the way to you.",
"An old friend or memory will surface. Let it, without rushing to name why.",
"A small act of service will open a door you were pushing on the wrong side of.",
"Rest is not a delay today — it is the work.",
"Do not commit to anything new before sunset. Listen first.",
"A creative spark returns. Capture it before evening.",
"Your instincts are sharper than the advice around you. Trust them.",
"A boundary spoken kindly will save you two weeks of confusion.",
"Something you thought was lost is only late. Have patience."
];
function dailyHoro(rk, dt) {
var seed = (dt.getUTCFullYear() * 1000 + dt.getUTCMonth() * 32 + dt.getUTCDate());
for (var i = 0; i < rk.length; i++) seed ^= rk.charCodeAt(i);
return HORO_THEMES[Math.abs(seed) % HORO_THEMES.length];
}
SK.data = { RASHIS:RASHIS, NAKSHATRAS:NAKSHATRAS, PLANETS:PLANETS, DASHA_YEARS:DASHA_YEARS, DASHA_ORDER:DASHA_ORDER, TRAITS:TRAITS, RECS:RECS, HORO_THEMES:HORO_THEMES, dailyHoro:dailyHoro };
})(window.SK = window.SK || {});
